import { initializeApp, getApps, getApp, FirebaseApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseApiKey = import.meta.env.VITE_FIREBASE_API_KEY;

if (!firebaseApiKey) {
    throw new Error("Missing VITE_FIREBASE_API_KEY. Add it to your environment before running the app.");
}

// Firebase configuration
const firebaseConfig = {
    apiKey: firebaseApiKey,
    authDomain: "aficionado-prod.firebaseapp.com",
    projectId: "aficionado-prod",
    storageBucket: "aficionado-prod.firebasestorage.app",
    messagingSenderId: "669315058362",
    appId: "1:669315058362:web:fa6da10dec379e68f59083",
    measurementId: "G-2VYSLV3ZDS"
};

// Initialize Firebase (Singleton Pattern)
let app: FirebaseApp;
if (!getApps().length) {
    try {
        app = initializeApp(firebaseConfig);
    } catch (error) {
        console.error("Firebase Initialization Error:", error);
        // If init fails, we can't recover easily.
        // We'll throw to ensure we don't pass undefined to getAuth.
        throw error;
    }
} else {
    app = getApp();
}

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
const functionsRegion = import.meta.env.VITE_FUNCTIONS_REGION || "us-central1";
export const functions = getFunctions(app, functionsRegion);
